import { CUSTOM_CATEGORIES } from 'utils/constants/casino/custom-categories';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import { CasinoGamesDefaultConstants } from './default-constants';
import {
  CasinoGamesConfigs,
  CasinoGamesLayoutType,
  CasinoGamesLoadMoreBtnType
} from '../providers/CasinoGamesConfigsContext';

export const computeCasinoLoadMoreButtonType = (
  configs: Partial<CasinoGamesConfigs>
): CasinoGamesLoadMoreBtnType => {
  return (
    (isMobile() && configs.mobileCustomSettings
      ? configs.mobileLoadMoreType
      : configs.loadMoreType) || CasinoGamesDefaultConstants.LOAD_MORE_TYPE
  );
};

export const computeCasinoGamesPerRow = (
  configs: Partial<CasinoGamesConfigs>
): number => {
  return (
    (isMobile() && configs.mobileCustomSettings
      ? configs.mobileGamesPerRow
      : configs.gamesPerRow) || CasinoGamesDefaultConstants.GAMES_PER_ROW
  );
};

export const computeCasinoGamesRows = (
  configs: Partial<CasinoGamesConfigs>
): number => {
  return (
    (isMobile() && configs.mobileCustomSettings
      ? configs.mobileGamesRows
      : configs.gamesRows) || CasinoGamesDefaultConstants.GAMES_ROWS
  );
};

export const computeCasinoGamesCountForSliderSkeleton = (
  configs: Partial<CasinoGamesConfigs>
): number => {
  return computeCasinoLoadMoreButtonType(configs) !==
    CasinoGamesLoadMoreBtnType.SLIDER
    ? computeCasinoGamesLimit(configs)
    : computeCasinoGamesRows(configs) * computeCasinoGamesPerRow(configs);
};

export const computeCasinoGamesLimit = (
  configs: Partial<CasinoGamesConfigs>
): number => {
  return (
    (isMobile() && configs.mobileCustomSettings
      ? configs.mobileCasinoGamesLimit
      : configs.casinoGamesLimit) ||
    CasinoGamesDefaultConstants.CASINO_GAMES_LIMIT
  );
};

export const computeCasinoGamesLoadMoreButtonEnabled = (
  configs: Partial<CasinoGamesConfigs>,
  selectedCategory: string
): boolean => {
  // these categories are getting games from promoted endpoint, which works very bad with pagination
  if (
    [CUSTOM_CATEGORIES.special.id, CUSTOM_CATEGORIES.specialLive.id].includes(
      selectedCategory
    )
  ) {
    return false;
  }

  return (
    (isMobile() && configs?.mobileCustomSettings
      ? configs.mobileShowLoadMoreBtn
      : configs.showLoadMoreBtn) ||
    CasinoGamesDefaultConstants.LOAD_MORE_BUTTON_ENABLED
  );
};

export const computeCasinoGamesArrowsEnabled = (
  configs: Partial<CasinoGamesConfigs>
): boolean => {
  return (
    (isMobile() && configs?.mobileCustomSettings
      ? configs.mobileShowArrow
      : configs.showArrowForMobile) ||
    CasinoGamesDefaultConstants.ARROWS_ENABLED
  );
};

export const computeCasinoGamesLayoutType = (
  configs: Partial<CasinoGamesConfigs>
): CasinoGamesLayoutType => {
  return configs.layoutType ?? CasinoGamesLayoutType.CLASSIC;
};

export const computeCasinoGamesCategoryNameVisible = (
  configs: Partial<CasinoGamesConfigs>,
  selectedCategory: string
): boolean => {
  if (SpringConfigs.DECENTRALIZED_CASINO_URL) {
    return false;
  }

  if (
    selectedCategory === CUSTOM_CATEGORIES.all.id &&
    !configs.groupAllByCategories
  ) {
    return false;
  }

  return (
    configs.showCategoryName ||
    CasinoGamesDefaultConstants.CATEGORY_NAME_VISIBLE
  );
};

export const computeLeftSideBarCasinoAvailable = (): boolean => {
  const matchCasinoUrl = new RegExp(`${SpringConfigs.PAGE_URLS.casino}/`);

  return (
    !isMobile() &&
    !!window.location.href.match(matchCasinoUrl) &&
    SpringConfigs.LEFT_SIDE_BAR &&
    SpringConfigs.LEFT_SIDE_BAR_CASINO
  );
};
